import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import ProjectCard from "./ProjectCards";
import Particle from "../Particle";
import editor from "../../Assets/Projects/3.jpg";
import chatify from "../../Assets/Projects/1.jpg";
import suicide from "../../Assets/Projects/2.jpg";
import olx from "../../Assets/Projects/olx.png";
import Tik from "../../Assets/Projects/Tik.png";
import eshop from "../../Assets/Projects/eshop.png";

function Projects() {
  return (
    <Container fluid className="project-section" id="project">
      <Particle />
      <Container>
        <h1 className="project-heading">
          My Recent <strong className="purple">Works </strong>
        </h1>
        <p style={{ color: "white" }}>
          Here are a few projects I've worked on recently.
        </p>
        <center>
          <h2>
            <strong className="purple"> Project</strong>
          </h2>
        </center>
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={eshop}
              isBlog={false}
              title="EShop "
              description="This project is about building an online E-commerce web application with backend integration showing the functionality of an e-commerce website with Payment Gateway etc."
              stacks="Tech Stack : React, Redux, Chakra-UI, Mongo-DB, Express Js"
              ghLink="https://github.com/VishalBhuse/E-Commerce-Repo"
              demoLink="https://ecommercemernapp.vercel.app/"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={chatify}
              isBlog={false}
              title="Modesens Clone"
              description="ModeSens is led by a team of industry experts who developed a solution to the disconnected and crowded online shopping experience."
              stacks="Tech Stack : React, Redux, Chakra-UI, Firebase"
              ghLink="https://github.com/VishalBhuse/Modesens"
              demoLink="https://modesens-vishalbhuse.vercel.app/"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={suicide}
              isBlog={false}
              title="Blue Heaven Cosmetics"
              description="Blue Heaven Cosmetics Private Limited is majorly in Manufacturing Cosmetics, Metals & Chemicals and products thereof."
              stacks="Tech Stack : HTML, JavaScript, Bootstrap , Swiper Js"
              ghLink="https://github.com/VishalBhuse/IndiaMart_Repo"
              demoLink="https://vishalbhuse.github.io/IndiaMart_Repo/"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={editor}
              isBlog={false}
              title="Fundamental Electronics "
              description="Fundamental Electronics Pvt. Ltd. is an online store where it provides the customer with the brands, products and services at the best price ."
              stacks="Tech Stack : HTML, CSS, JavaScript, Bootstrap"
              ghLink="https://github.com/VishalBhuse/Fundamental.in"
              demoLink="https://fundamnetal-in.netlify.app/"
            />
          </Col>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={olx}
              isBlog={false}
              title="OLX Clone"
              description="Creating clone of OLX platform. OLX makes it so easy to connect people to buy, sell or exchange used goods and services."
              stacks="Tech Stack : React, Redux, Chakra-UI, Swiper Js"
              ghLink="https://github.com/VishalBhuse/deluxe-key-8268"
              demoLink="https://olx-clone-vishal-bhuse.vercel.app/"
            />
          </Col>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={Tik}
              isBlog={false}
              title="Tik Tak Toe "
              description="Tic-tac-toe, noughts and crosses, or Xs and Os is a paper-and-pencil game for two players who take turns marking the spaces in a three-by-three grid with X or O."
              stacks="Tech Stack : React, JavaScript"
              ghLink="https://github.com/VishalBhuse/Tic_Tak_Toe"
              demoLink="https://vishalbhuse.github.io/Tic_Tak_Toe/"
            />
          </Col>
        </Row>
      </Container>
    </Container>
  );
}

export default Projects;
